import Datepicker from '../../ui/Datepicker.vue';
import { useField } from 'vee-validate';


export default {
  __name: 'DateOfIllnessField',
  setup(__props, { expose }) {
  expose();

const { value, errorMessage } = useField('dateOfIllness');

const minDate = new Date().setDate(new Date().getDate() - 2);
const maxDate = new Date().setDate(new Date().getDate() + 2);

const __returned__ = { value, errorMessage, minDate, maxDate, Datepicker, get useField() { return useField } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

}